import { render, staticRenderFns } from "./orders-details-container.vue?vue&type=template&id=b0ccb7ea&scoped=true&lang=pug"
import script from "./orders-details-container.js?vue&type=script&lang=js&external"
export * from "./orders-details-container.js?vue&type=script&lang=js&external"
import style0 from "./orders-details-container.vue?vue&type=style&index=0&id=b0ccb7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ccb7ea",
  null
  
)

export default component.exports